import React, { useState } from 'react';
import { Dialog } from '../../../../../../components/Dialog';
import { DeleteCompanyDialog } from '../DeleteCompanyDialog';
import { S } from './DeleteCompanyButton.styles';

type Props = {
  companyId: string;
  /** Compact trash icon for accordion rows */
  iconOnly?: boolean;
};

export const DeleteCompanyButton: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog.Provider isOpen={isOpen}>
      <Dialog.Trigger>
        <S.Trigger
          type="button"
          aria-label="Radera bolag"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        >
          <S.Icon src="Trash" height={22} color="secondary" />
          {!props.iconOnly && <S.H6 color="secondary">Radera</S.H6>}
        </S.Trigger>
      </Dialog.Trigger>

      <DeleteCompanyDialog
        companyId={props.companyId}
        onClose={() => setIsOpen(false)}
      />
    </Dialog.Provider>
  );
};
